import {
  GooglePlacesAutocompleteInput,
  PlaceSelection,
} from './GooglePlacesAutocompleteInput'

interface Props {
  value: string
  onChange: (value: string) => void
  onBlur?: () => void
  name?: string
  placeholder?: string
  disabled?: boolean
  required?: boolean
}

/**
 * Autocompletado de Google para direcciones que se guardan en **una sola columna**
 * (dirección del beneficiario, del médico, del dueño de la póliza…).
 *
 * Se diferencia del que usa PolicyHolderTab: allá la dirección vive partida en
 * `address1` / `city` / `stateEU` / `zipCode`, así que hay que descomponer los
 * `addressComponents`. Acá el modelo tiene un único CharField, por lo que se guarda
 * el `formatted_address` completo que devuelve Google, ya normalizado.
 */
export const AddressAutocompleteInput: React.FC<Props> = ({
  value,
  onChange,
  onBlur,
  name,
  placeholder,
  disabled,
  required,
}) => {
  const handlePlaceSelect = ({address}: PlaceSelection) => {
    // `address` es el formatted_address de Google; si no viene, se respeta lo tipeado.
    if (address) onChange(address)
  }

  return (
    <GooglePlacesAutocompleteInput
      name={name}
      value={value ?? ''}
      placeholder={placeholder}
      disabled={disabled}
      required={required}
      // Coincide con el CharField(255) del modelo. Una dirección de Google ronda los
      // 100 caracteres, así que esto no molesta al usar el autocompletado; está para
      // el caso de escribir o pegar a mano, donde un valor más largo haría fallar el
      // INSERT y se perdería todo el formulario.
      maxLength={255}
      onChange={(e) => onChange(e.target.value)}
      onBlur={onBlur}
      onPlaceSelect={handlePlaceSelect}
    />
  )
}
